// item.js
// wrapper component for leaf-level element
// a switcher for required item type
// e.g.: form / display widget items
// Default item type is 'input.text'

import {get} from 'lodash'

import request from 'superagent'
import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import * as Actions from './redux/actions'

import ItemTypes from './item-types'

import {normalizeSchemaKey, requestMapToQueryString, _t, transformUrl, validUserLogin, getAuthToken} from './lib/utils'

class Item extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id              : this.props.id,
      schema          : this.props.schema,
      classes         : get(this.props, 'AXGClasses.item', ''),
      showCondition   : get(this.props, 'schema.show', true),
      show            : get(this.props, 'schema.show', true),
      account         : this.props.account,
      data            : get(this.props, 'schema.data.fallback'),
      title           : _t(get(this.props, 'schema.title', this.props.id)),
    }
  }

  fetchData() {
    var component = this
    var dataSrc = get(this.state, 'schema.data')
    console.info(`item: ${this.props.AXGKey} -> fetchData from: ${JSON.stringify(dataSrc)}`)
    // this.mockFetchData()
    if (dataSrc) {
      let endpoint = get(dataSrc, 'endpoint')
      let endpointTransform = get(dataSrc, 'transform')
      let method = get(dataSrc, 'method', 'POST')
      let requestMap = get(dataSrc, 'request-map')
      let responseMap = get(dataSrc, 'response-map')
      let canCall = ['GET', 'POST', 'PUT', 'DELETE', 'HEAD', 'OPTIONS', 'CONNECT'].includes(method)

      endpoint = transformUrl(endpoint, endpointTransform, component.props.appxigonState)

      if (requestMap && method.toUpperCase() === 'GET') {
        endpoint = `${endpoint}?${requestMapToQueryString(requestMap, component.props.appxigonState)}`
      }
      console.info(`_ item: calling: ${endpoint}`)

      canCall
      && request[method.toLocaleLowerCase()](endpoint)
        .set('Accept', 'application/json')
        .set('token', getAuthToken())
        .end((err, res) => {
          if (res) {
            // console.log(`res.body: ${JSON.stringify(res.body)}`)
            component.setState({
              // data: get(res.body, 'data')
              data: res.body
            })
          }
          if (err) {
            console.log(`ITEM: error: ${JSON.stringify(err)}`)
            component.setState({
              data: {error: "Can't load data from server ..."}
            })
          }
        })
    }
  }

  getDataFromStore(storeKey) {
    // console.info(` ... storeKey: ${storeKey}`)
    return get(this.props.appxigonState, storeKey)
  }

  componentWillReceiveProps(nextProps) {
    let component = this
    let dataDef = get(this.state, 'schema.data')
    // console.info(` ... ${this.props.AXGKey}: componentWillReceiveProps`)
    // console.info(` ... dataDef: ${dataDef}`)
    // console.info(` ... data: ${get(nextProps.appxigonState, dataDef)}`)
    if (typeof dataDef == 'string') {
      component.setState({
        data: get(nextProps.appxigonState, dataDef)
      })
    }

    // pickup dependency trigger
    var dependencyKey = `dependency.${this.props.AXGKey}`
    var nextDepencyValue = get(nextProps.appxigonState, dependencyKey, '')
    if (nextDepencyValue && this.state.dependency != nextDepencyValue) {
      console.log(`item: ${this.props.AXGKey}: dependency changed`)
      console.info(`__ item: ${this.props.AXGKey}: refetching data ...`)
      setTimeout(() => { this.fetchData() }, 2000)
      // quick hack to rerun actions of the button click
      // this.handleActions()
    }
    this.setState({
      dependency: nextDepencyValue,
    })
  }

  componentWillMount() {
    let component = this
    let dataDef = get(this.state, 'schema.data')
    let endpoint = get(this.state, 'schema.data.endpoint')
    let fallback = get(this.state, 'schema.data.fallback')
    // console.info(` ... ${component.props.AXGKey}: dataDef: ${dataDef}`)
    // console.info(` ... typeof dataDef: ${typeof dataDef}`)
    switch (typeof dataDef) {
      case 'string':
        component.setState({
          data: component.getDataFromStore(dataDef)
        })
        break
      case 'object':
        // TODO: make fetchData return data directly
        if (endpoint) {
          setTimeout(() => { this.fetchData() }, 200)
        } else if (fallback) {
          component.setState({
            data: fallback
          })
        }
        break
      default:
        component.setState({
          data: ''
        })
    }
  }

  render() {
    const defaultType = 'todo-item-type'
    const defaultValue = get(this.props, 'schema.data.default')
    var ItemType = ItemTypes[defaultType] // default item type
    var type = get(this.props, 'schema.type', defaultType)
    // console.info(`__ type: ${type}`)
    // console.log(`id / show: ${this.state.id} / ${JSON.stringify(this.state.showCondition)} ${typeof this.state.showCondition}`)
    // console.log(`AXGState: ${JSON.stringify(this.props.AXGState)}`)

    // _________ Show / Hide condition checking
    var show = this.state.show
    var stateRefKey = ''
    var stateRefVal = ''
    // console.log(`showCondition: ${JSON.stringify(this.state.showCondition)}`)
    if (typeof this.state.showCondition === 'boolean') {
      show = this.state.showCondition
    } else if (typeof this.state.showCondition === 'string') {
      // TODO: generic handling of pre-defined conditions
      // account.authenticated
      // REVIEW: untimely update incidentally solved by passing down props: account from root component
      if (this.state.showCondition === 'account.authenticated') {
        // show = localStorage.getItem('Appxigon.loginToken') !== null
        show = validUserLogin()
        // console.info(`Appxigon.loginToken: ${localStorage.getItem('Appxigon.loginToken')}`)
        // console.info(`account.authenticated check: ${show}`)
        // show = this.state.account.loginToken !== null
      }
      if (this.state.showCondition === 'account.rejected') {
        // APOLLO-TODO: proper error condition from REDUX
        show = !validUserLogin()
      }
    } else {
      // object of conditions
      // TODO: handle multiple conditions
      let conditionKey = Object.keys(this.state.showCondition)[0]
      let conditionVal = this.state.showCondition[conditionKey]
      stateRefKey = normalizeSchemaKey(conditionKey, this.props.AXGKey)
      show = (get(this.props.appxigonState, [stateRefKey]) === conditionVal)
              ? true
              : false

      // console.info(` ------- show: ${this.props.AXGKey}: ${show} stateRefKey: ${stateRefKey}`)
      // console.info(` ------- show: ${this.props.AXGKey}: ${show} conditionVal: ${conditionVal}`)
    }
    // console.info(`item: show ${this.props.AXGKey}: ${show}`)

    // ---------- Get data for current item ----------
    var data = this.state.data
    // var dataKey = get(this.props, 'schema.data')
    // console.info(`${this.props.AXGKey}: dataKey: ${JSON.stringify(dataKey)}`)
    // data:
    // 1. dataKey is string
    // 1a. '$ref.' -> fetch from parameters AXGState[dataKey] . (TODO: caching ?)
    //             -> immediate consume?
    // 1b. 'some.other.key' -> get from AXGState[dataKey] (normalizedKey)
    //                      -> only update when asked?
    // 2. dataKey is object with endpoint, method, request-map, response-map, transformation etc...
    // -> same as $ref ? Use hidden action.button ?

    // console.log(`id / display: ${this.state.id} / ${show}`)
    if (typeof ItemTypes[type] !== 'undefined') {
      ItemType = ItemTypes[type]
    }
    return (
        show
        && <ItemType
            id={this.state.id}
            title={this.state.title}
            schema={this.state.schema}
            defaultValue={defaultValue}
            data={data}
            show={show}
            value={this.props.value}
            AXGKey={this.props.AXGKey}
            AXGClasses={this.props.AXGClasses}
            AXGOptions={this.props.AXGOptions}
            AXGDataSource={this.props.AXGDataSource}/>
    )
  }
}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
    appxigonAccount: state.AXGAccount,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Item)



// WEBPACK FOOTER //
// ./item.js